import React, { useState, useEffect } from 'react';
import { getHoroscope } from '../api/horoscopeApi';
import { constellationData } from '../data/constellationData';
import './HoroscopePage.css';

const constellationNames = Object.keys(constellationData);
const timePeriods = [
  { value: 'today', label: '今日运势' },
  { value: 'week', label: '本周运势' },
  { value: 'month', label: '本月运势' },
];

const HoroscopePage = () => {
  const [selectedSign, setSelectedSign] = useState('aries');
  const [selectedPeriod, setSelectedPeriod] = useState('today');
  const [horoscope, setHoroscope] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchHoroscope = async () => {
      setLoading(true);
      const result = await getHoroscope(selectedSign, selectedPeriod);
      setHoroscope(result);
      setLoading(false);
    };

    fetchHoroscope();
  }, [selectedSign, selectedPeriod]);

  return (
    <>
      <title>星座运势查询 - 星座探秘</title>
      <meta name="description" content="查询指定星座的今日、本周、本月运势。选择您的星座，获取最新的运势解读。" />
      <div className="horoscope-page">
        <h1>星座运势查询</h1>
        <div className="controls">
          <select value={selectedSign} onChange={(e) => setSelectedSign(e.target.value)}>
            {constellationNames.map(name => (
              <option key={name} value={name}>{constellationData[name].chineseName}</option>
            ))}
          </select>
          <div className="period-tabs">
            {timePeriods.map(period => (
              <button 
                key={period.value} 
                className={selectedPeriod === period.value ? 'active' : ''}
                onClick={() => setSelectedPeriod(period.value)}
              >
                {period.label}
              </button>
            ))}
          </div>
        </div>
        <div className="horoscope-result">
          {loading ? <p>正在加载...</p> : <p>{horoscope}</p>}
        </div>
      </div>
    </>
  );
};

export default HoroscopePage;
